import styled from 'styled-components'
import {
  alignItems,
  AlignItemsProps,
  flexDirection,
  FlexDirectionProps,
  height,
  HeightProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & AlignItemsProps>`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  gap: ${themeGet('space.8')}px;

  ${flexDirection}
  ${alignItems}
`

export const Card = styled.div<HeightProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex-grow: 1;
  border-radius: 16px;
  overflow: hidden;
  background-color: ${themeGet('colors.background.screen')};
  box-shadow: ${themeGet('shadows.block')};

  > img {
    width: 100%;
    height: 300px;
    object-fit: cover;
  }

  ${height}
`
